/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import PageContentContainer from "../../../Container/PageContentContainer";
import CaseFullForm from "../../../Case/CaseForm/Full/CaseFullForm";
import NavigationExtensionAllData from "../../../NavigationBar/NavigationExtensionAllData";
import { ProductHeadline } from "../../../PageHeadline/PageHeadline";
import LegalBirdPageLoading from "../../../ContentLoader/LegalBirdPageLoading";
import { useCase } from "../../../../provider/CaseProvider";

const ExternalsCaseAllDataPage = () => {
  const { product, isLoading } = useCase();
  if (isLoading) {
    return <LegalBirdPageLoading />;
  }

  if (!product) {
    return null;
  }

  return (
    <>
      <NavigationExtensionAllData />
      <PageContentContainer size={"small"}>
        <ProductHeadline title="Alle Details zum Fall von" product={product} />
        <CaseFullForm product={product} formDisabled={true} refreshPage={() => {}} />
      </PageContentContainer>
    </>
  );
};

export default ExternalsCaseAllDataPage;
